import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { LinesDrainsQuestionnaireItem } from './questionnaire'

export const LINES_DRAINS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [LinesDrainsQuestionnaireItem.MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
